import React from 'react'

const SkipLinks = () => {
    return (
        <nav className="skip-links">
            <h2 className="sr-only">Dodatkowe menu</h2>
            <a className="skiplink" href="#about">Przejdź do informacji o mnie</a>
            <a className="skiplink" href="#works">Przejdź do informacji o moich projektach</a>
            <a className="skiplink" href="#contact">Przejdź do kontaktu ze mną</a>
        </nav>
    )
}

export default SkipLinks
